<template>
  <md-dialog :md-active.sync="show" :md-close-on-esc="false" @md-opened="openDialog" @md-clicked-outside="closeDialog"
    @keyup.esc="closeDialog" @keyup.enter="submitBtn">
    <md-dialog-title>{{ title }}</md-dialog-title>
    <div class="md-dialog-content md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
      <form>
        <md-field class="md-layout-item md-small-size-100 md-size-100 password-layout"
          :class="errors.invalidClasses.password">
          <label> New password </label>
          <md-input v-model="requestParams.password" type="password" required></md-input>
          <ValidationError :errors="errors.messages.password" />
        </md-field>
      </form>

      <div class="md-layout-item md-size-100 text-right">
        <md-button @click="closeDialog">Close</md-button>
        <md-button class="md-primary" @click="submitBtn">{{ submitBtnText }}</md-button>
      </div>
    </div>
  </md-dialog>
</template>

<script>
import { ref } from "@vue/composition-api";
import apiManager from "@/api-manager";
import camelCaseObjectKeysToSnakeCase from "@/utils/camelCaseObjectKeysToSnakeCase";
import ValidationError from "./ValidationError.vue"

export default {
  name: "SetPassword",
  components: {
    ValidationError
  },
  props: {
    title: {
      default: "Set Password",
      type: String,
    },
    submitBtnText: {
      default: "Set",
      type: String,
    },
    show: {
      type: Boolean,
    },
    adminPk: {
      type: Number,
    },
  },
  setup(props, { emit }) {
    const requestParams = ref({});
    const errors = ref({
      invalidClasses: "",
      messages: ""
    });

    const closeDialog = () => {
      emit("close");
    };

    const resetErrors = () => {
      errors.value = {
        invalidClasses: "",
        messages: ""
      };
    };
    const resetParams = () => {
      requestParams.value = {
        adminPk: -1,
        password: "",
      };
    };
    const openDialog = () => {
      resetErrors();
      resetParams();
    };

    const submitBtn = async () => {
      resetErrors();
      requestParams.value.adminPk = props.adminPk;

      const response = await apiManager.patchAdmin({
        params: camelCaseObjectKeysToSnakeCase(requestParams.value),
      });
      if (response.data.stat === "OK") {
        emit("changed");
      } else {
        errors.value = response.processed_errors;
      }
    };

    return {
      requestParams,
      errors,

      closeDialog,
      openDialog,

      submitBtn,
    };
  },
};
</script>

<style lang="scss" scoped>
.new-pass {
  margin-bottom: -8px;
}
</style>